import React from "react";
import OrderTaskForm from "./OrderTaskForm";

const SOLICITUD = {
  title: "Solicitud",
  fields: [
    ["cliente_nombre", "Cliente"],
    ["empresa", "Empresa"],
    ["cliente_telefono", "Teléfono"],
    ["cliente_email", "Email"],
    ["items", "Productos solicitados"],
    ["notas", "Notas"],
  ],
};
const COTIZACION = {
  title: "Cotización",
  fields: [
    ["monto_cotizado", "Monto cotizado"],
    ["validez_dias", "Validez (días)"],
    ["condiciones", "Condiciones"],
  ],
};
const STAGES = ["Solicitud", "Cotización", "Respuesta"];
// Tarea «Preparar cotización» (actor VENTAS) — FORMCODE ELCOT2
const CONFIG = {
  stage: 1,
  stages: STAGES,
  title: "Preparar cotización",
  intro: "Revisa la solicitud y define el monto y las condiciones.",
  sections: ["custom"],
  customSections: [SOLICITUD],
  inputsTitle: "Cotización",
  inputs: [
    { name: "monto_cotizado", label: "Monto cotizado", type: "number", required: true },
    { name: "validez_dias", label: "Validez (días)", type: "number", placeholder: "Ej: 15" },
    { name: "condiciones", label: "Condiciones", type: "textarea", placeholder: "Forma de pago, plazo de entrega…" },
  ],
  skipRequiredFor: ["Descartar solicitud"],
  optionHints: {
    "Cotización lista": "Pasa a Enviar al cliente.",
    "Descartar solicitud": "Cierra la solicitud sin cotizar.",
  },
};

export default function ElevaxPrepararCotizacion(props) {
  return <OrderTaskForm {...props} config={CONFIG} />;
}
